<template>
  <v-container fluid>
    <h1>Content Builder</h1>
    <ContentBuilder v-model="page" />
    <hr />
    <!-- {{ page }} -->
  </v-container>
</template>

<script>
/* eslint-disable */

export default {
  name: "PageBuilderTest",
  // route: {
  //   path: "/page-builder-test/",
  //   name: "PageBuilder",
  // },
  components: {
    ContentBuilder: () =>
      import("../components/ContentBuilder/ContentBuilder.vue"),
  },
  data() {
    return {
      page: [
        {
          tag: "h1",
          innerHtml: "Hello World",
        },
        {
          tag: "p",
          innerHtml:
            "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. In elementum mollis quam, dignissim feugiat risus hendrerit a. Nulla bibendum consequat lectus sit amet rhoncus. Donec mattis condimentum elit at posuere. Integer a sapien enim. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis eget lectus enim.",
        },
        {
          tag: "p",
          innerHtml:
            "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. In elementum mollis quam, dignissim feugiat risus hendrerit a. Nulla bibendum consequat lectus sit amet rhoncus. Donec mattis condimentum elit at posuere. Integer a sapien enim. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis eget lectus enim.",
        },
      ],
    };
  },
};
</script>

<style></style>
